@if (data()) { @if (shippingBucket()) {
<p data-testing-id="shippingMethodName">{{ shippingBucket().shippingMethod?.name }}</p>
@if (shippingBucket().desiredDeliveryDate) {
<div>
  <strong>{{ 'checkout.widget.shipping_method.desired_delivery_date' | translate }}</strong>
  <p data-testing-id="desiredDeliveryDate">{{ shippingBucket().desiredDeliveryDate | ishDate }}</p>
</div>
} } @else {
<p data-testing-id="shippingMethodName">{{ data().commonShippingMethod?.name }}</p>
@if (desiredDeliveryDate) {
<div>
  <strong>{{ 'checkout.widget.shipping_method.desired_delivery_date' | translate }}</strong>
  <p data-testing-id="desiredDeliveryDate">{{ desiredDeliveryDate | ishDate }}</p>
</div>
} } }
